<script>

import { oAuthLogin, authorizeUnredirect, crateCaptcha, getClientName } from '@/api/common/index'
import { Toast } from 'vant'

export default {
  data() {
    return {
      region: '',
      mobileRegion: '',
      source: '',
      tipShow: false,
      tipContent: '',
      tipButton: '',
      loginData: {},
      isCaptcha: false,
      captchaSrc: '',
      clientName: ''
    }
  },

  methods: {

    showLoading(msg = '') {
      Toast.loading({
        message: msg,
        forbidClick: true,
        duration: 0
      })
    },

    dismissLoading() {
      Toast.clear()
    },

    authorization() {
      const clientId = this.$store.getters.externalParam.client_id
      const responseType = this.$store.getters.externalParam.response_type
      const redirectUri = this.$store.getters.externalParam.redirect_uri
      const scope = this.$store.getters.externalParam.scope
      const state = this.$store.getters.externalParam.state

      return {
        responseType: responseType,
        clientId: clientId,
        redirectUri: redirectUri,
        scope: scope,
        state: state
      }
    },

    isValidEmail(email) {
      const reg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      return reg.test(email)
    },

    isValidPassword(password) {
      if (password.indexOf(' ') !== -1) {
        return false
      }

      if (/[\u4e00-\u9fa5]/.test(password)) {
        return false
      }

      const reg = /((?=.*\d)(?=.*[a-zA-Z])|(?=.*\d)(?=.*[^a-zA-Z0-9])|(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9])).{6,20}/
      return reg.test(password)
    },

    showTipPopup(content, button) {
      this.tipContent = content
      this.tipButton = button
      this.tipShow = true
    },

    /**
     * 用于协议详情页切换语言，本地文案的国际化
     * @param {*} lang
     */
    setLanguage(lang) {
      if (['en_US', 'zh_CN', 'ko_KR'].indexOf(lang) !== -1) {
        this.$store.dispatch('user/setLanguage', lang)
      }
    },

    getParamFromHost(){
      // 手工获取url参数
      var allParam = {}
      var url = window.location.href
      if (url.indexOf('#') !== -1) {
        url = url.split('#')[0]
      }
      url.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m, key, value) {
        allParam[key] = decodeURIComponent(value)
      })
      return allParam
    },

    initParamterForProtocol(){
      // 这里需要修改document.title
      document.title = this.$t('云米')
      const param = this.$route.query
      if (this.$store.getters.manulRegionCode?.length > 0) {
        param.region = this.$store.getters.manulRegionCode
      }
      this.source = param.source
      this.region = param.region || window.defaultRegionCode
      this.$store.dispatch('user/setExternalParam', param)
    },

    initParamter() {
      let param = this.$route.query
      const allParam = this.getParamFromHost()
      // Amazon Alexa 海外OAuth不支持hash模式，无法获取query参数，也无法传递到下一个页面，注意子类页面不能直接获取this.$route.query使用
      if (Object.keys(param).length === 0) {
        param = allParam // 如果param有参数，要考虑拼接，并以param为准
      } else {
        param = Object.assign(allParam, param)
      }

      if (this.$store.getters.manulRegionCode?.length > 0) {
        param.region = this.$store.getters.manulRegionCode
      }

      this.source = param.source
      this.region = param.region || window.defaultRegionCode
      this.mobileRegion = this.region

      // 不用清空，使用期间保持用户选择
      if (this.$store.getters.selectMobileRegionCode.length > 0) {
        this.mobileRegion = this.$store.getters.selectMobileRegionCode
      }

      // 但是接口请求头需要维持原有region
      this.$store.dispatch('user/setExternalParam', param).then(() => {
        if (this.$store.getters.mobilePrefixList.length === 0) {
          this.$store.dispatch('config/getAreaConfigInfo')
        }

        if (param.clientName || this.$store.getters.clientName) {
          this.clientName = param.clientName || this.$store.getters.clientName
        } else {
          const clientId = this.$store.getters.externalParam.client_id || ''
          getClientName({ client_id: clientId }).then(res => {
            if (res.code === 100) {
              this.clientName = res.mobBaseRes.result.name
              this.$store.dispatch('user/setClientName', this.clientName)
            }
          })
        }
      })
    },

    getCrateCaptcha (data) {
      this.showLoading(this.$t('加载图形验证码'))
      crateCaptcha(data).then(res => {
        this.dismissLoading()
        if (res.code === 100) {
          this.isCaptcha = true
          this.captchaSrc = res.mobBaseRes.result
        } else {
          this.showTipPopup(res.desc, this.$t('确定'))
        }
      }).catch((error) => {
        this.dismissLoading()
        this.showTipPopup(error, this.$t('确定'))
      })
    },

    tryToRequestAreaConfigInfo() {
      const that = this
      return new Promise((resolve, reject) => {
        if (this.$store.getters.mobilePrefixList.length === 0) {
          that.showLoading()
          this.$store.dispatch('config/getAreaConfigInfo').then((res) => {
            that.dismissLoading()
            resolve(res)
          }).catch((err) => {
            that.dismissLoading()
            reject(err)
          })
        } else {
          resolve(this.$store.getters.mobilePrefixList)
        }
      })
    },

    commonAuth(data) {
      const that = this
      that.showLoading()
      oAuthLogin(data).then(res => {
        console.log(this.source)
        if (res.code === 100) {
          this.loginData = res.mobBaseRes.result
          this.loginData.authorization = this.authorization()
          if (this.source === 'h5') {
            authorizeUnredirect(this.loginData).then(res => {
              that.dismissLoading()
              var ua = window.navigator.userAgent.toLowerCase()
              if (res.mobBaseRes.code === 100) {
                if (ua.indexOf('android') !== -1) {
                  window.viomiBridge.loginResult(res.mobBaseRes.result.code)
                } else {
                  window.webkit.messageHandlers.LoginResult.postMessage(res.mobBaseRes.result.code)
                }
              } else {
                this.showTipPopup(res.desc, this.$t('确定'))
              }
            })
          } else {
            authorizeUnredirect(this.loginData).then(res => {
              that.dismissLoading()
              if (res.mobBaseRes.code === 100) {
                window.location.href = `${res.mobBaseRes.result.redirectUri}?code=${res.mobBaseRes.result.code}&state=${res.mobBaseRes.result.state}`
              } else {
                this.showTipPopup(res.desc, this.$t('确定'))
              }
            })
          }
        } else {
          that.dismissLoading()
          this.showTipPopup(res.desc, this.$t('确定'))
        }
      }).catch(err => {
        that.dismissLoading()
        this.showTipPopup(err, this.$t('确定'))
      })
    }
  }
}
</script>
